import { configureStore } from "@reduxjs/toolkit";
import navbarSlice from "./Slices/NavbarSlice";
import loaderReducer from "./Slices/LoaderSlice";
import collegesReducer from "./Slices/CollegeSlice"
import documentsReducer from "./Slices/DocumentSlice"
import marqueeReducer from "./Slices/MarqueeSlice"
import courseReducer from "./Slices/CourseSlice"
import eventsReducer from "./Slices/EventSlice"
import recruitersReducer from "./Slices/RecruiterSlice"
import clubsReducer from "./Slices/ClubSlice"
import newsReducer from "./Slices/NewsSlice"
export default configureStore({
  reducer: {
    navbar: navbarSlice,
    loader: loaderReducer,
    colleges: collegesReducer,
    documents: documentsReducer,
    marquees: marqueeReducer,
    courses: courseReducer,
    events: eventsReducer,
    recruiters: recruitersReducer,
    clubs: clubsReducer,
    news: newsReducer,
  },
});
